import React, { useEffect, useState } from "react";

const DateBanner = ({ startDate, imgSrc }) => {
  const [days, setDays] = useState(0);

  useEffect(() => {
    const start = new Date(startDate);
    const today = new Date();

    const diffTime = today - start;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

    setDays(diffDays);
  }, [startDate]);

  return (
    <div className="-mt-[2vw] w-full h-auto relative text-center overflow-hidden z-30">
      {imgSrc && (
        <>
          <img
            src={imgSrc}
            alt={"배너 이미지"}
            className="object-contain"
          />
        </>
      )}
      <div className="-mt-[2vw] text-blue-500 font-mochiy" style={{ fontSize: '2vw' }}>
        D+{days}
      </div>
    </div>
  );
};

export default DateBanner;
